import { render, staticRenderFns } from "./VictoriaBrand.vue?vue&type=template&id=1a79ca54&scoped=true&"
import script from "./VictoriaBrand.vue?vue&type=script&lang=js&"
export * from "./VictoriaBrand.vue?vue&type=script&lang=js&"
import style0 from "./VictoriaBrand.vue?vue&type=style&index=0&id=1a79ca54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a79ca54",
  null
  
)

export default component.exports